import React from 'react';
import { evaluatePassword, PASSWORD_RULE_LABELS, type PasswordRequirements as Requirements } from './passwordRules';

const CHECK = 'M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z';
const CROSS = 'M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z';

/** Checklist de requisitos. O estado (atendido ou não) também vai no texto para leitores de tela. */
const PasswordRequirements: React.FC<{ password: string }> = ({ password }) => {
  const result = evaluatePassword(password);
  return (
    <div className="space-y-1.5 rounded-panel border border-line bg-surface-muted px-4 py-3 text-xs">
      <p className="mb-2 font-semibold text-fg">A senha deve conter:</p>
      {(Object.keys(PASSWORD_RULE_LABELS) as (keyof Requirements)[]).map((key) => {
        const ok = result[key];
        return (
          <div key={key} className={`flex items-center gap-2 ${ok ? 'text-success-text' : 'text-fg-muted'}`}>
            <svg aria-hidden="true" className="h-3.5 w-3.5 shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" clipRule="evenodd" d={ok ? CHECK : CROSS} />
            </svg>
            <span>{PASSWORD_RULE_LABELS[key]}</span>
            <span className="sr-only">{ok ? '(atendido)' : '(pendente)'}</span>
          </div>
        );
      })}
    </div>
  );
};

export default PasswordRequirements;
